export const Status = {
  ACTIVE: "Active",
  IN_ACTIVE: "Inactive",
  DEPRICATED: "Deprecated",
};
export const PageHeaders = {
  Organization: "Organizations",
  Resource: "Resources",
};
export const Locations = {
  OrgLocation: "/Organization",
  ResLocation: "/Resource",
};
export const format = {
  dateFormat: "MMM dd, yyyy",
};
export const ClinithinkRequest = {
  requestMsg: "Contact Clinithink to request more",
};
export const resRoles = {
  resMangerRole: "Resource.Manager",
  resWriteRole: "Resource.Write",
  resReadRole: "Resource.Read",
};
export const unSubscribeRes = {
  unSubscribeText:
    " Unsubscribing means you and your connected organizations will lose access to this version of the resource as well as any future updates to it.",
  unSubscribeQues: "Unsubscribe from this resource?",
};

export const SubscribedRes = {
  SubscribedRes_msg: "View organization's subscribed resources from here",
};
export const Roles = {
  SUPER_USER: "Super.User",
  ORG_ADMIN: "Organisation.Admin",
  ENG_READER_ROLE: "Engine.Telemetry.Reader",
  OP_READER_ROLE: "Operational.Telemetry.Reader",
  Resource_Manager: "Resource.Manager",
  Resource_Write: "Resource.Write",
  Resource_Read: "Resource.Read",
};
export const userRoles = localStorage.getItem("items");
export const getUserRoles = () => {
  const item = localStorage.getItem("items");
  try {
    return item ? JSON.parse(item) : [];
  } catch (error) {
    console.error("Error parsing user roles from localStorage:", error);
    return []; // Return an empty array as a fallback
  }
};

export const RequiredMessages = {
  Description: "Description is required",
  AccessURL: "Access url is required",
  EnvironmentName: "Environment name is required",
};
export const ErrorMessages = {
  DataReceiptFileTypes: "Please select file types",
  Certificate: "You need to upload a valid certificate file to create a new environment",
  ValidateCertificate: "Please upload a valid certificate(.cer, .pem, .crt)",
  ProblemOccured: "problem occurred, please try again",
  DateExceed: "Start Date should be less than End Date",
};
export const ApiSuccessMsgs = {
  AzureADCopy: "Azure AD group ID Copied Successfully",
  OrganisationCreate: "Partner organization created successfully",
  OrganisationUpdate: "Partner organization updated successfully",
  EnvironmentUpdate: "Environment updated successfully",
  ClientIDCopied: "Client ID Copied Successfully",
  EnvironmentCreate: "Environment created successfully",
  CertificateUpdate: "Certificate updated successfully",
  resDownload: "Resource downloaded successfully",
  ResCreated: "Resource successfully uploaded",
  ResourceIdCopied: "Resource version ID copied successfully ",
};
export const classes = {
  buttonAttrForCancelButton: {
    class: "cancelButtonClassForOrg",
  },
  buttonAttrForSaveButton: {
    class: "saveButtonClassForOrg",
  },
};
export const widths = {
  width: "auto",
};
export const Placeholders = {
  Dates: "Date",
  Description: "Write a description",
  Email: "Email",
  Phone: "Phone",
  Website: "Website",
  Name: "Name",
  EnvironmentName: "Enter environment name",
  URL: "Enter in (https://www.testXXX.com) format",
  File_Types: "Select file types",
  SearchProfile: "Search by resource name",
};
export const OrgFormConsts = {
  dateEditOptionsForCreate: {
    placeholder: Placeholders.Dates,
    invalidDateMessage: "Value must be a date",
    max: new Date(),
  },
  orgDetailsEditOption: {
    width: widths.width,
    height: 100,
    placeholder: Placeholders.Description,
    maxLength: 500,
  },
  emailEditOption: {
    width: widths.width,
    placeholder: Placeholders.Email,
  },
  phoneEditOption: {
    placeholder: Placeholders.Phone,
  },
  websiteEditOption: {
    width: widths.width,
    placeholder: Placeholders.Website,
  },
  nameEditorOptions: {
    width: widths.width,
    placeholder: Placeholders.Name,
    mode: "username",
  },
  buttonAttrForSaveButton: {
    class: "saveButtonClassForOrg",
  },
  buttonAttrForCancelButton: {
    class: "cancelButtonClassForOrg",
  },
};
export const manifestMessages = {
  Manifest_heading: "Manifest results",
  Valid_success: "Validation successful",
  Valid_failed: "Validation failed",
  doesnt_contain: " Manifest does not contain expected fields.",
  check: "Please check and try again.",
  Mandatory: " Mandatory fields not present in manifest eg.",
  Zip: " Zip file does not contain manifest. Please try again.",
};
export const availableUserRoles = {
  Resource_Manager: "Resource.Manager",
  Engine_Telemetry_Reader: "Engine.Telemetry.Reader",
  Organisation_Admin: "Organisation.Admin",
  Super_User: "Super.User",
  Resource_Write: "Resource.Write",
  Resource_Read: "Resource.Read",
  Operational_Telemetry_Reader: "Operational.Telemetry.Reader",
};
export const headerDescription = {
  orgDesc: "Manage your organizational data from here ",
  resDesc: "Create and manage resources from here ",
};
export const environmentFormConsts = {
  accessUrRLOptions: {
    placeholder: Placeholders.URL,
  },
  descriptionOptions: {
    placeholder: Placeholders.Description,
    height: 100,
    maxLength: 500,
  },
  dropdownoptionsForEnv: {
    height: 200,
  },
  dropdownoptionsForEditEnv: {
    height: 350,
  },
  envNameOptions: {
    placeholder: Placeholders.EnvironmentName,
  },
};
export const UploadPlaceHolders = {
  ResourceUploadPlaceHolder: "Drop zip file here or click to upload.",
};
export const PRIVACY_POLICY_URL = "https://www.clinithink.com/privacy-policy-2/";
export const TERMS_OF_USE_URL = "https://www.clinithink.com/terms-of-use";

export const defaultPageSize = 10;
export const defaultPageNumber = 1;
